import { render } from "./TempestLogo.vue?vue&type=template&id=034b966e&scoped=true"
const script = {}

import "./TempestLogo.vue?vue&type=style&index=0&id=034b966e&scoped=true&lang=css"

import exportComponent from "/home/heather/Documents/Work/Soldel/pwa2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034b966e"]])

export default __exports__